module.exports = __webpack_public_path__ + "img/portfolio-img1.01b3c504.png";